module.exports = __webpack_public_path__ + "img/4left-925a44dc.png";